


























import IconBase from "@/common/components/atoms/IconBase.vue";
import IconLoop from "@/common/components/icons/IconLoop.vue";
import { Vue, Component, Prop } from "vue-property-decorator";
import commons from "@/common/store/modules/commons";
import loginInfo from "@/general/store/modules/loginInfo";

@Component({
  components: { IconBase, IconLoop }
})
export default class HeaderNaviSwitchButtonForSpLayout extends Vue {
  @Prop({ type: Boolean, required: false, default: false }) ssoFlg!: boolean;
  @Prop({ type: Boolean, required: false, default: false })
  switchState!: boolean;

  get colorCode() {
    if(this.isGroupBudget) {
      return '#fc9014'
    }
    return commons?.colorCode;
  }

  get isGroupBudget() {
    return commons?.userInfo.groupBudgetMode
  }

  async created() {
    this.ssoFlg = loginInfo.isSso;
  }

  emitClickEvent() {
    this.$emit("click-change-modal-state");
  }
}
